import Marquee from "react-fast-marquee";

const items = [
  "24/7 Customer Support",
  "Data Entry & Processing",
  "Back-Office Operations",
  "Multilingual Teams",
  "99.9% SLA Uptime",
  "Voice · Chat · Email",
];

const MarqueeBand = () => (
  <section data-testid="marquee-section" className="border-y border-[#0A0F1C]/10 bg-[#E8EDF5] py-5">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {items.map((item) => (
        <span
          key={item}
          className="mx-8 flex items-center gap-8 font-display text-lg font-bold uppercase tracking-[0.15em] text-[#0A0F1C] md:text-xl"
        >
          {item}
          <span className="text-sky-600">◆</span>
        </span>
      ))}
    </Marquee>
  </section>
);

export default MarqueeBand;
